import { render, staticRenderFns } from "./profitReport.vue?vue&type=template&id=64af3068&scoped=true&"
import script from "./profitReport.vue?vue&type=script&lang=js&"
export * from "./profitReport.vue?vue&type=script&lang=js&"
import style0 from "./profitReport.vue?vue&type=style&index=0&id=64af3068&lang=stylus&scoped=true&"
import style1 from "./profitReport.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af3068",
  null
  
)

export default component.exports